/** !
 * xman - xpopup.js
 *
 * Copyright(c) 2014 Alibaba Group Holding Limited.
 * Authors:
 *   宗羽 <xiaochen.gaoxc@alibaba-inc.com> (http://github.com/gxcsoccer)
 */


/**
 * Module dependencies.
 */

module.exports = function (cb) {
  if (cb) {
    if (window.SCHD_COMS.SCXman) {
      cb(window.SCHD_COMS.SCXman);
    } else if (window.SCHD_COMS && window.SCHD_COMS.use) {
      window.SCHD_COMS.use(['xman'], () => {
        if (window.SCHD_COMS.SCXman) {
          cb(window.SCHD_COMS.SCXman);
        }
      });
    }
  }
};
